export default __webpack_public_path__ + "static/media/banner.030f0787.png";